import { Textarea } from '@chakra-ui/react';
import { ChangeEvent, RefObject, useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FormWidgetData } from 'widgets/FormWidget/FormWidget.types';
import { useEditor, useWidget } from 'widgets/sdk';

export const SelectionFieldQuestion = ({ isLabelFocused = false }) => {
  const { t } = useTranslation('editor_widget_toolbar', { useSuspense: false, keyPrefix: 'formToolbar' });
  const {
    field: { label },
    updateWidget,
    isWidgetSelected,
  } = useWidget<FormWidgetData>();
  const { isSideWidgetMenuOpen } = useEditor();
  const [localLabel, setLocalLabel] = useState(label);
  const inputRef = useRef<HTMLInputElement | HTMLTextAreaElement>(null);

  const updateValue = useCallback(
    (e: ChangeEvent<HTMLTextAreaElement>) => {
      let newValue = e.target.value;
      // remove empty spaces
      if (newValue.trim() === '') {
        newValue = '';
      }
      setLocalLabel(newValue);
      updateWidget({ field: { label: newValue || '' } });
    },
    [updateWidget],
  );

  // Highlight the label input text when the label is focused and the side menu is open
  useEffect(() => {
    if (isWidgetSelected && isLabelFocused && inputRef.current && isSideWidgetMenuOpen) {
      const timer = setTimeout(() => {
        inputRef.current?.focus();
        // Make sure the cursor is at the end of the input
        if (inputRef.current) {
          const length = inputRef.current.value.length;
          inputRef.current.setSelectionRange(0, length);
        }
      }, 0);

      return () => clearTimeout(timer);
    }
  }, [isLabelFocused, isWidgetSelected, isSideWidgetMenuOpen]);

  return (
    <Textarea
      ref={inputRef as RefObject<HTMLTextAreaElement>}
      resize='none'
      placeholder={t('settingsSideBar.question.question')}
      value={localLabel}
      onChange={updateValue}
      borderRadius='base'
      borderColor='chakra-border-color'
      _hover={{
        borderColor: 'gray.300',
        backgroundColor: 'hover.gray',
      }}
      fontSize='sm'
      isInvalid={!localLabel.trim()}
    />
  );
};

SelectionFieldQuestion.displayName = 'SelectionFieldQuestion';

export default SelectionFieldQuestion;
